import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-340a7280")

_pushScopeId("data-v-340a7280")
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "mr-3 w-10 h-10 reject-icon flex items-center justify-center" }
const _hoisted_3 = { class: "text-2xl" }
const _hoisted_4 = { class: "mt-6 reject-reason" }
const _hoisted_5 = { class: "text-sm font-bold" }
const _hoisted_6 = { class: "flex justify-end mt-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ApproveIcon = _resolveComponent("ApproveIcon")
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_component_Popup, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShow = $event)),
    classes: "reject-form-popup",
    width: "1056px",
    noScrollBody: ""
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_ApproveIcon, { color: '#fff' })
        ]),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('approveMultiple')), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('approverMessage')), 1),
        _createVNode(_component_Input, {
          class: "mt-1 h-12",
          modelValue: _ctx.reasonApprove,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.reasonApprove = $event)),
          required: "",
          placeholder: _ctx.t('pleaseEnter')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Button, { onClick: _ctx.submitAllReason }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t('approveRecord')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})